import { call, put, takeLatest, takeEvery, all } from 'redux-saga/effects';
import { getAllGenerator } from 'helpers/resourceSagas';
import * as api from './api';
import * as types from './types';
import * as actions from './actions';

import { createSubmissionError } from 'forms/utils';
import { info, error } from 'notifications/actions';

export const getAll = getAllGenerator({
  resourceType: 'paymentMethods',
  endpoint: api.getAll,
  endpointArgs: (payload) => [ payload.userId ],
  transformResponse: (resp) => resp.data,
});

export function* setDefault(action) {
  const { id } = action.payload;
  try {
    yield put(actions.setDefaultPending(id));
    const resp = yield call(api.setDefault, id);
    yield put(actions.setDefaultSucceeded(resp));
    yield put(actions.getAll());
  }
  catch (err) {
    yield put(actions.setDefaultFailed(id));
  }
}

export function* create({ payload }) {
  try {
    yield put(actions.createPending());
    const resp = yield call(api.create, payload);
    yield put(actions.createSucceeded(resp));
    yield put(actions.create.success(resp));
    yield put(info('newCard', 'New payment method added successfully'));
  }
  catch (err) {
    const { response } = err;
    const message = response.data.detail || response.data[0] || 'Please correct the errors';
    const submissionError = createSubmissionError(response);
    yield put(actions.createFailed());
    yield put(actions.create.failure(submissionError))
    yield put(error('newCard', message));
  }
}

export function* destroy(action) {
  const { cardId, userId } = action.payload;
  try {
    yield put(actions.destroyPending(cardId));
    yield call(api.destroy, userId, cardId);
    yield put(actions.destroySucceeded(cardId));
    yield put(info('newCard', 'Payment method deleted successfully'));

  }
  catch (err) {
    const { response } = err;
    const message = response.data.detail ||
                    response.data.message ||
                    response.data[0] ||
                    'Failed to remove payment method';
    yield put(actions.destroyFailed(cardId));
    yield put(error('newCard', message));
  }
}

export function* watchGetAll() {
  yield takeLatest(types.GET_ALL, getAll);
}

export function* watchSetDefault() {
  yield takeLatest(types.SET_DEFAULT, setDefault);
}

export function* watchCreate() {
  yield takeEvery(actions.create.REQUEST, create);
}

export function* watchDestroy() {
  yield takeEvery(types.DESTROY, destroy);
}

export function* watchPaymentMethods() {
  yield all([
    call(watchGetAll),
    call(watchSetDefault),
    call(watchCreate),
    call(watchDestroy),
  ]);
}

